import { Component, OnInit } from '@angular/core';

import { AppConfigService } from 'src/app/Services/app-config.service';
import { CruiseRegionsService } from 'src/app/Services/cruiseregions.service';
import { CruiseItineraryService } from 'src/app/Services/cruiseitinerary.service';
import { ItinInfoService } from 'src/app/Services/itin-info.service';
import { ExcursionDialogComponent } from '../excursion-dialog/excursion-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UserData } from 'src/app/Models/employee-and-user-data';

type ExcursionData = {
  ExcursionId: string;
  Description: string;
  ImageUrl: string;
  Title: string;
};

@Component({
  selector: 'app-itinerary-explorer',
  templateUrl: './itinerary-explorer.component.html',
  styleUrls: ['./itinerary-explorer.component.css'],
})
export class ItineraryExplorerComponent implements OnInit {
  CruiseRegionsInfo: any;
  cruiseregiondata: any;
  CruiseThemesInfo: any;
  cruisethemedata: any;
  CruiseItineraryInfo: any;
  cruiseitinerarydata: any;
  userdata?: UserData;
  selectedRegion: string = '';
  selectedItinerary: string = '';
  itininfodata: any;
  ItinInfo: any;
  mapexpander: boolean = false;
  reverselink: boolean = false;
  displayselectedItinerary: string | undefined;

  excursionmap = new Map<String, ExcursionData>();
  OBRebookMaint: boolean = false;

  constructor(
    private CruiseRegionService: CruiseRegionsService,
    private CruiseItineraryService: CruiseItineraryService,
    private ItinInfoService: ItinInfoService,
    private appConfigService: AppConfigService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.OBRebookMaint = this.appConfigService.OBRebookMaint;
    this.getCruiseRegions();
  }
  getCruiseRegions() {
    this.cruiseregiondata =
      this.CruiseRegionService.GetCruiseRegions().subscribe(
        (cruiseregiondata) => this.setCruiseRegions(cruiseregiondata)
      );
  }
  setCruiseRegions(resdata: any) {
    this.cruiseregiondata = resdata;
    if (this.cruiseregiondata.GetCruiseRegions.Result.Status == 'A') {
      this.CruiseRegionsInfo =
        this.cruiseregiondata.GetCruiseRegions.CruiseRegionList;
    }
  }
  setRegion(selectregion: string) {
    this.selectedRegion = selectregion;
    this.selectedItinerary = '';
    this.ItinInfo = undefined;
    this.getCruiseItinerariesFiltered();
  }
  setItinerary(selectitinerary: string) {
    this.selectedItinerary = selectitinerary;
    for (let i = 0; i < this.CruiseItineraryInfo.length; i++) {
      if (this.CruiseItineraryInfo[i].creRegionID == selectitinerary) {
        this.displayselectedItinerary =
          this.CruiseItineraryInfo[i].creItinerary;
      }
    }
    this.getItinInfo();
  }
  getCruiseItinerariesFiltered() {
    this.cruiseitinerarydata =
      this.CruiseItineraryService.GetCruiseItinerariesFiltered(
        undefined,

        undefined,
        this.selectedRegion,
        undefined
      ).subscribe((cruiseitinerarydata) =>
        this.setCruiseItinerariesFiltered(cruiseitinerarydata)
      );
  }
  setCruiseItinerariesFiltered(resdata: any) {
    this.cruiseitinerarydata = resdata;
    if (this.cruiseitinerarydata.GetCruiseItineraries.Result.Status == 'A') {
      this.CruiseItineraryInfo =
        this.cruiseitinerarydata.GetCruiseItineraries.CruiseItineraryList;
    }
  }
  getItinInfo() {
    this.itininfodata = this.ItinInfoService.GetItinInfo(
      this.selectedItinerary
    ).subscribe((itininfodata) => this.setItinInfo(itininfodata));
  }
  setItinInfo(resdata: any) {
    this.itininfodata = resdata;
    if (this.itininfodata.GetItinInfo.Result.Status == 'A') {
      this.ItinInfo = this.itininfodata.GetItinInfo.ItinInfo;
      for (let i = 0; i < this.ItinInfo.Excursions.length; i++) {
        this.excursionmap.set(
          this.ItinInfo.Excursions[i].ExcursionId,
          this.ItinInfo.Excursions[i]
        );
      }
    }
  }
  showexcursion(exursionitem: ExcursionData) {
    const dialogRef = this.dialog.open(ExcursionDialogComponent, {
      panelClass: 'excursiondialog',
      maxHeight: '90vh',
      data: {
        exursionitem,
      },
    });
  }
}
